export default function useAnimations() {
  function getAnimationConfig(
    entry: IObserveEntry,
    delay: number,
    direction: ANIMATION_DIRECTION
  ) {
    visibilityChanged(entry.isIntersecting, entry, delay, direction);
  }

  function visibilityChanged(
    isVisible: boolean,
    entry: IObserveEntry,
    delay: number,
    direction: ANIMATION_DIRECTION
  ) {
    if (isVisible && !entry.target.animated) {
      if (delay) entry.target.classList.add(`delay-${delay}s`);
      setTimeout(() => {
        entry.target.classList.remove('invisible');
        entry.target.classList.add('animated');
        entry.target.classList.add(`fadeIn${direction}`);
        entry.target.animated = true;

        // Cleanup animation classes
        setTimeout(() => {
          entry.target.classList.remove('animated');
          entry.target.classList.remove(`fadeIn${direction}`);
        }, (delay | 1) * 2000);
      }, delay);
    }
  }

  function getAnimationDirection(index: number, quotient: number) {
    ++index;
    if (index % quotient === 0) {
      return ANIMATION_DIRECTION.RIGHT;
    }
    return index % quotient === 1
      ? ANIMATION_DIRECTION.LEFT
      : ANIMATION_DIRECTION.DOWN;
  }

  function fadeElement(
    element: HTMLElement & { faded: boolean },
    immediate = false
  ) {
    if (!element || !element?.style) return;

    let i = 0;
    if (element.faded) return;
    if (immediate) {
      element.style.fill = '#F4B400';
      element.style.fillOpacity = '1';
      return;
    }

    const interval: ReturnType<typeof setInterval> = setInterval(() => {
      if (i === 1) return clearInterval(interval);
      element.style.fill = '#F4B400';
      element.faded = true;

      element.style.fillOpacity =
        Number(element.style.fillOpacity) > i
          ? element.style.fillOpacity
          : i.toString();
      element.style.opacity = element.style.fillOpacity;

      i += 0.1;
    }, 50);
  }

  return { getAnimationConfig, getAnimationDirection, fadeElement };
}

export enum ANIMATION_DIRECTION {
  LEFT = 'Left',
  RIGHT = 'Right',
  BOTTOM_LEFT = 'BottomLeft',
  BOTTOM_RIGHT = 'BottomRight',
  UP = 'Up',
  DOWN = 'Down',
}

export interface IObserveEntry {
  isIntersecting: boolean;
  target: HTMLElement & { animated: boolean };
}
